import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import { contactUsAsync } from '../_redux/auth.api'

const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/

function ContactUs() {
  const [ContactModal, setContactModal] = useState(false)
  const handleClose = () => setContactModal(false)
  const handleShow = () => setContactModal(true)

  const dispatch = useDispatch()

  const ContactUsSchema = () =>
    Yup.object().shape({
      emailId: Yup.string()
        .trim()
        .when('showField', {
          is: 'email',
          then: Yup.string()
            .email('Wrong email format')
            .min(3, 'Minimum 3 characters')
            .max(50, 'Maximum 50 characters'),
        })
        .required('Email ID is required'),
      contactNumber: Yup.string()
        .trim()
        .when('showField', {
          is: 'phone',
          then: Yup.string().matches(
            phoneRegExp,
            'Contact Number is not valid',
          ),
        })
        .required('Phone is required'),
      name: Yup.string()
        .trim()
        .min(1, 'Please enter valid name')
        .max(50, 'Maximum 50 symbols')
        .required('Name is required'),
      message: Yup.string()
        .trim()
        .min(1, 'Please enter valid name')
        .max(50, 'Maximum 50 symbols')
        .required('Message is required'),
    })

  const onContactUs = (values) => {
    handleShow()
    dispatch(
      contactUsAsync({
        name: values.name,
        emailId: values.emailId,
        contactNumber: values.contactNumber,
        message: values.message,
      }),
    )
  }

  return (
    <>
      <Formik
        initialValues={{
          name: '',
          emailId: '',
          contactNumber: '',
          message: '',
        }}
        validationSchema={ContactUsSchema}
        onSubmit={(values, { resetForm }) => {
          onContactUs(values)
          resetForm({ values: '' })
        }}
      >
        {({ handleSubmit, touched, errors }) => (
          <>
            <div className="bg-white">
              <div className="abt_sc_1 mt-5 mb-15">
                <div className="container container_frnt">
                  <div className="row justify-content-center">
                    <div className="col-md-12">
                      <div className="top_img">
                        <img
                          alt=""
                          src={toAbsoluteUrl('/media/others/contact_img.jpg')}
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="col-md-8 mt-20 text-center">
                      <h2 className="def_hdng_v1 mb-10">
                        <span className="grbg_rndd">Contact</span> Us
                      </h2>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="cn_wt_bx">
                            <i className="fas fa-map-marker-alt color_blue"></i>
                            <h6 className="fn_s_18 f-w-400 color_blk mt-3">
                              ID GOLD Association Zürich, Switzerland
                            </h6>
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="cn_wt_bx">
                            <i className="fas fa-phone-alt color_blue d-block mb-3"></i>
                            <Link
                              to="#"
                              className="fn_s_18 f-w-400 color_blk mt-3"
                            >
                              +02 1234 567
                            </Link>
                          </div>
                        </div> */}
                        <div className="col-md-6">
                          <div className="cn_wt_bx">
                            <i className="fas fa-envelope color_blue d-block mb-3"></i>
                            <Link
                              to="#"
                              className="fn_s_18 f-w-400 color_blk mt-3"
                            >
                              info@qrfidgold.com
                            </Link>
                          </div>
                        </div>
                        <div className="col-md-12 text-left">
                          <h3 className="text-center fn_s_22 f-w-400 color_blk mt-15 mb-10">
                            Any question or remarks? Just write us a message!
                          </h3>
                          <Form
                            className="contact_form"
                            onSubmit={handleSubmit}
                          >
                            <div className="form-group">
                              <label className="control-label">Name</label>
                              <i className="fas fa-user"></i>
                              <Field
                                type="text"
                                name="name"
                                className="form-control wtpddng"
                              />
                              {touched.name && errors.name ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {errors.name}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                            <div className="form-group">
                              <label className="control-label">Email</label>
                              <i className="fas fa-envelope"></i>
                              <Field
                                type="text"
                                name="emailId"
                                className="form-control wtpddng"
                              />
                              {touched.emailId && errors.emailId ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {errors.emailId}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                            <div className="form-group">
                              <label className="control-label">Phone</label>
                              <i className="fas fa-mobile-alt"></i>
                              <Field
                                type="text"
                                className="form-control wtpddng"
                                name="contactNumber"
                              />
                              {touched.contactNumber && errors.contactNumber ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {errors.contactNumber}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                            <div className="form-group">
                              <label className="control-label">Message</label>
                              <i className="fa fa-comment"></i>
                              <Field
                                type="textarea"
                                className="form-control wtpddng"
                                name="message"
                                rows="3"
                              />
                              {touched.message && errors.message ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {errors.message}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                            <div className="form-group text-center mt-10">
                              <button
                                type="submit"
                                className={`btn btn-def defwtarw`}
                              >
                                <span>Send Message</span>
                              </button>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal
              show={ContactModal}
              onHide={handleClose}
              centered
              className="def_modal cntct_modal"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body className="text-center">
                <img
                  alt=""
                  src={toAbsoluteUrl('/media/others/message-outline.png')}
                  className="img-fluid mb-10"
                />
                <h3 className="fn_s_28 color_blk f-w-500">
                  Thank you for your message!
                </h3>
                <p className="fn_s_16 f-w-400 text-center mb-5 mt-5 opacity60 mx326">
                  Morbi egestas lorem ipsum nulla lobor posuere. Sed et iaculis
                  dui vitae lorem convallis leo.
                </p>
              </Modal.Body>
            </Modal>
          </>
        )}
      </Formik>
    </>
  )
}

export default ContactUs
